export const VendorUnitpriceType = [
  { label: '上代', value: '1' },
  { label: '仕入単価', value: '2' },
];
